import React from 'react';
import MoveToFolderDialog from './MoveToFolderDialog';
import performBulkAction from 'components/inbox/utils/performBulkAction';
import Button from '@material-ui/core/Button';
import MailActions from 'actions/inbox/MailActions';
import FolderActions from 'actions/inbox/FolderActions';
import './InboxItemActionButtons.styl';
import {BookmarkIcon} from '@components/icon/BookmarkIcon';
import {TrashIcon} from '@components/icon/TrashIcon';
import {EnvelopeCircleCheckIcon} from '@components/icon/EnvelopeCircleCheckIcon';
import {LocationDotIcon} from '@components/icon/LocationDotIcon';

export default class InboxItemActionButtons extends React.PureComponent {
  constructor(props) {
    super(props);
    this.moveToTrash = this.moveToTrash.bind(this);
    this.markAsRead = this.markAsRead.bind(this);
    this.pinItems = this.pinItems.bind(this);
    this.moveToFolder = this.moveToFolder.bind(this);
    this.getBulkActionTarget = this.getBulkActionTarget.bind(this);
    this.state = {};
    this.performBulkAction = (action, actionText) =>
      performBulkAction({
        targets: this.props.targets,
        areAllSelected: this.props.areAllSelected,
        action,
        actionText,
      }).then(this.props.onActionCompleted);
  }

  getBulkActionTarget() {
    const {targets, areAllSelected, filters} = this.props;
    const ids = targets.map(target => target.getIds()).flatten();
    // ids are reverse selected ids negated with areAllSelected = true
    const target = areAllSelected ? {filters, ids} : {ids};
    // folder id that is for some reason required by api
    const folderId = areAllSelected ? filters.folderId : targets.first().folderId;
    return {target, folderId};
  }

  async moveToTrash() {
    const trashFolder = this.props.folders.find(folder => folder.isTrash());
    const {target, folderId} = this.getBulkActionTarget();
    this.performBulkAction(
      () =>
        Promise.all([
          MailActions.bulkMarkAsRead({
            ...target,
            folderId,
          }),
          MailActions.bulkSetPinned({
            ...target,
            folderId,
            pinned: false,
          }),
          MailActions.bulkMoveFolder({
            ...target,
            from: folderId,
            to: trashFolder.id,
          }),
        ]),
      actionTarget => `Moved  ${actionTarget} to trash`
    ).then(FolderActions.fetchFolders);
  }

  markAsRead() {
    const {target, folderId} = this.getBulkActionTarget();

    this.performBulkAction(
      () =>
        MailActions.bulkMarkAsRead({
          ...target,
          folderId,
        }),
      actionTarget => `Marked ${actionTarget} as read`
    ).then(FolderActions.fetchFolders);
  }

  pinItems() {
    const {target, folderId} = this.getBulkActionTarget();

    this.performBulkAction(
      () =>
        MailActions.bulkSetPinned({
          ...target,
          folderId,
          pinned: true,
        }),
      actionTarget => `Pinned ${actionTarget}`
    );
  }

  async moveToFolder(destFolderId) {
    const {target, folderId} = this.getBulkActionTarget();

    await this.performBulkAction(
      () =>
        MailActions.bulkMoveFolder({
          ...target,
          from: folderId,
          to: destFolderId,
        }),
      actionTarget =>
        `Moved ${actionTarget} to folder ${
          this.props.folders.find(folder => folder.id === destFolderId).name
        }`
    );
    FolderActions.fetchFolders();
    this.setState({showMoveToFolderDialog: false});
  }

  render() {
    return (
      <div className="inbox-item-action-buttons">
        {this.props.showMoveToFolder && (
          <Button
            variant="text"
            className="ev-button"
            onClick={() => this.setState({showMoveToFolderDialog: true})}>
            <BookmarkIcon /> Move to folder
          </Button>
        )}
        {this.props.showMoveToTrash && (
          <Button variant="text" className="ev-button" onClick={this.moveToTrash}>
            <TrashIcon /> Move to trash
          </Button>
        )}
        {this.props.showMarkAsRead && (
          <Button variant="text" className="ev-button" onClick={this.markAsRead}>
            <EnvelopeCircleCheckIcon /> Mark read
          </Button>
        )}
        {this.props.showPin && (
          <Button variant="text" className="ev-button" onClick={this.pinItems}>
            <LocationDotIcon /> Pin
          </Button>
        )}
        {this.state.showMoveToFolderDialog && (
          <MoveToFolderDialog
            targets={this.props.targets}
            areAllSelected={this.props.areAllSelected}
            folders={this.props.folders}
            currentFolderId={
              this.props.areAllSelected
                ? this.props.filters.folderId
                : this.props.targets.first().folderId
            }
            onRequestClose={() => this.setState({showMoveToFolderDialog: false})}
            onRequestMove={this.moveToFolder}
          />
        )}
      </div>
    );
  }
}
